module.exports = __webpack_public_path__ + "static/media/Language.a5b35c62.JPG";